"use strict";

var _regeneratorRuntime = require("/var/www/honeyguideapps_guides/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEditor = useEditor;
exports["default"] = Editor;
exports.OP_ARRAY_INSERT = exports.OP_ARRAY_REMOVE = exports.OP_NORMAL = exports.FORM_STATE_ERROR = exports.FORM_STATE_NORMAL = exports.FORM_STATE_BUSY = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Get the EditorContext


var EditorContext = _react["default"].createContext();

var FORM_STATE_BUSY = 'busy';
exports.FORM_STATE_BUSY = FORM_STATE_BUSY;
var FORM_STATE_NORMAL = 'normal';
exports.FORM_STATE_NORMAL = FORM_STATE_NORMAL;
var FORM_STATE_ERROR = 'error';
exports.FORM_STATE_ERROR = FORM_STATE_ERROR;
var OP_NORMAL = 0;
exports.OP_NORMAL = OP_NORMAL;
var OP_ARRAY_REMOVE = 1;
exports.OP_ARRAY_REMOVE = OP_ARRAY_REMOVE;
var OP_ARRAY_INSERT = 2;
exports.OP_ARRAY_INSERT = OP_ARRAY_INSERT;

function createManager(initialState, parent, onChange, onSubmit) {
  var state = initialState;
  var formState = FORM_STATE_NORMAL;
  var namedSubscriptions = {};
  var mappedSubscriptions = [];
  var validators = [];
  var requiresSubmit = 0;
  var manager = {
    getParent: function getParent() {
      return parent;
    },
    getState: function getState() {
      return state;
    },
    getFormState: function getFormState() {
      return formState;
    },
    dispatch: function dispatch(name, value) {
      var op = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : OP_NORMAL;
      var newValue = typeof value === 'function' ? value(state[name]) : value;
      var prevValue = state[name];

      if (prevValue === newValue) {
        return;
      }

      var newState = Array.isArray(state) ? state.slice() : Object.assign({}, state);

      if (op === OP_ARRAY_INSERT) {
        newState.splice(name, 0, value);
      } else if (op === OP_ARRAY_REMOVE) {
        newState.splice(name, 1);
      } else {
        newState[name] = newValue;
      }

      state = newState; // let all the listeners know that the value has changed

      var subscriptions = namedSubscriptions[name];

      if (subscriptions && subscriptions.length > 0) {
        subscriptions.forEach(function (fn) {
          return fn(newValue);
        });
      }

      mappedSubscriptions.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            listener = _ref2[0],
            mapper = _ref2[1];

        return listener(mapper(newState));
      }); // Trigger the on change event

      if (!requiresSubmit && onChange) {
        onChange(newState);
      }
    },
    subscribe: function subscribe(name, listener) {
      if (typeof name === 'function') {
        var tuple = [listener, name];
        mappedSubscriptions.push(tuple);
        return function () {
          var idx = mappedSubscriptions.indexOf(tuple);
          mappedSubscriptions.splice(idx, 1);
        };
      }

      var arr = namedSubscriptions[name] || [];

      if (!arr.length) {
        namedSubscriptions[name] = arr;
      }

      arr.push(listener);
      return function () {
        var idx = arr.indexOf(listener);
        arr.splice(idx, 1);

        if (arr.length === 0) {
          delete namedSubscriptions[name];
        }
      };
    },
    validate: function validate(check, fn) {
      var validation = {
        done: null,
        confirm: function confirm() {
          if (validation.done !== null) {
            return validation.done;
          }

          return validation.run(typeof check === 'function' ? check(state) : state[check]);
        },
        run: function run(value) {
          validation.done = fn(value);
          return validation.done;
        },
        remove: function remove() {
          var idx = validators.indexOf(validation);

          if (idx >= 0) {
            validators.splice(idx, 1);
          }
        }
      };
      validators.push(validation);
      return validation;
    },
    registerSubmit: function registerSubmit() {
      requiresSubmit += 1;
      return function () {
        requiresSubmit -= 1;
      };
    },
    submit: function () {
      var _submit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                formState = FORM_STATE_BUSY;
                _context.next = 4;
                return Promise.all(validators.map(function (v) {
                  return v.confirm();
                }));

              case 4:
                res = _context.sent;

                if (!res.reduce(function (r, d) {
                  return r || d === false;
                }, false)) {
                  _context.next = 8;
                  break;
                }

                formState = FORM_STATE_ERROR;
                return _context.abrupt("return", false);

              case 8:
                formState = FORM_STATE_NORMAL;
                if (onChange) onChange(state);
                if (onSubmit) onSubmit(state);
                return _context.abrupt("return", true);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                formState = FORM_STATE_ERROR;
                return _context.abrupt("return", false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14]]);
      }));

      function submit() {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  };
  return manager;
}

function useEditor() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var instance = (0, _react.useContext)(EditorContext);
  return parent || instance;
}

function Editor(_ref3) {
  var value = _ref3.value,
      onChange = _ref3.onChange,
      onSubmit = _ref3.onSubmit,
      parent = _ref3.parent,
      other = _objectWithoutProperties(_ref3, ["value", "onChange", "onSubmit", "parent"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      instance = _useState2[0],
      setInstance = _useState2[1];

  (0, _react.useEffect)(function () {
    if (instance !== null) {
      // eslint-disable-next-line no-console
      console.warn('The editor onChange parameter is not expected to change');
    }

    setInstance(createManager(value, parent, onChange, onSubmit)); // The useEffect hook is expected to be called only once,
    // hence, a warning above and dependency on `onChange` only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange]);

  if (instance === null) {
    return null;
  }

  return _react["default"].createElement(EditorContext.Provider, _extends({
    value: instance
  }, other));
}

Editor.defaultProps = {
  parent: null
};